import React, { useContext, useEffect, useState } from "react";
import { Avatar, List, Skeleton, Button, Typography, Card, Empty, Tabs, Row, Col, Pagination } from "antd";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import useRequest from "../../hooks/useRequest";
import apiPath from "../../constants/apiPath";
import InfiniteScroll from "react-infinite-scroll-component";
import lang from "../../helper/langHelper";
import { Severty, ShowToast } from "../../helper/toast";
import DeleteModal from "../../components/DeleteModal";
import { DeleteOutlined } from "@ant-design/icons";
import { AppStateContext, useAppContext } from "../../context/AppContext";
import Main from "../../components/layout/Main";
import TabPane from "antd/lib/tabs/TabPane";
import PushNotification from "./Notification";
import NotificationTemplate from "./NotificationTemplate";

export const NotificationList = () => {
  const { setPageHeading } = useContext(AppStateContext);
  setPageHeading("Notification Management");
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [list, setList] = useState([]);
  const [selected, setSelected] = useState("");
  const [show, setShow] = useState(false);
  const [showAllDelete, setShowAllDelete] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const { language, setRefreshNotification } = useAppContext();

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const navigate = useNavigate();
  const { request } = useRequest();

  const dates = {
    today: moment(new Date()).format("YYYY-MM-DD"),
    yesterday: moment(new Date().getTime() - 24 * 60 * 60 * 1000).format(
      "YYYY-MM-DD"
    ),
  };

  const fetchData = (page = pagination.current, pageSize = pagination.pageSize) => {
    setLoading(true);
    request({
      url: `admin/notification/notification-user?status=${""}&page=${page}&pageSize=${pageSize}&search=${""}`,
      method: "GET",
      onSuccess: ({ data }) => {
        setList(data?.data ?? []);
        setPagination({
          current: data?.page || page,
          pageSize: data?.pageSize || pageSize,
          total: data?.total || 0,
        });
        setLoading(false);
      },
      onError: (err) => {
        console.log(err);
        setLoading(false);
      },
    });
  };

  const handlePageChange = (page, pageSize) => {
    fetchData(page, pageSize);
  };

  useEffect(() => {
    fetchData(1, pagination.pageSize);
  }, [refresh]);

  const handleNavigate = (noti) => {
    if (noti.use_for === "Vendor") {
      navigate("/vendor");
    } else if (noti.use_for === "user") {
      navigate("/user");
    }

    if (noti.use_for && !noti?.is_read) {
      request({
        url: `${apiPath.notification}/read/${noti?._id}`,
        method: "POST",
        onSuccess: ({ data }) => {
          ShowToast(lang("Notification Read Successfully"), Severty.SUCCESS);
          setRefresh((prev) => !prev);

          setTimeout(() => {
            setRefreshNotification(true);
          }, 20);
        },
        onError: (err) => {
          console.log(err);
        },
      });

      setTimeout(() => {
        fetchData();
      }, 2000);
    }
  };

  const deleteNotification = (id) => {
    setLoading(true);
    request({
      url: `${apiPath.notification}/delete/${selected}`,
      method: "DELETE",
      onSuccess: ({ data, message }) => {
        ShowToast(message, Severty.SUCCESS);
        setRefresh((prev) => !prev);
        setLoading(false);
        setSelected("");
        // setTimeout(() => {
        //   setRefreshNotification(true);
        // }, 20);
      },
      onError: (err) => {
        ShowToast(err?.response?.data?.message, Severty.ERROR);
        console.log(err);
        setLoading(false);
      },
    });
  };

  const readAllNotifcation = () => {
    request({
      url: `${apiPath.notification}/read`,
      method: "POST",
      onSuccess: ({ data }) => {
        ShowToast(lang("Notification  Read All Successfully"), Severty.SUCCESS);
        setRefresh((prev) => !prev);
        // setTimeout(() => {
        //   setRefreshNotification(true);
        // }, 20);
      },
      onError: (err) => {
        console.log(err);
      },
    });
  };

  const markNotification = (id) => {
    setLoading(true);
    request({
      url: `${apiPath.notification}/mark-done/${id}`,
      method: "PUT",
      onSuccess: ({ data, message }) => {
        ShowToast(message, Severty.SUCCESS);
        setRefresh((prev) => !prev);
        setLoading(false);
        setSelected("");
        // setTimeout(() => {
        //   setRefreshNotification(true);
        // }, 20);
      },
      onError: (err) => {
        ShowToast(err?.response?.data?.message, Severty.ERROR);
        console.log(err);
        setLoading(false);
      },
    });
  };

  return (
    <>
      <Card
        bordered={false}
        className="criclebox tablespace mb-24"
        title="Notification Listing"
        extra={
          <>
            <div className="main-dltall-not-all">
              <Button
                disabled={!list?.length}
                className="deleteall-main-button"
                onClick={() => {
                  setShowAllDelete(true);
                }}
              >
                {lang("Delete All")}
              </Button>
              <Button
                disabled={!list?.length}
                className="deleteall-main-button"
                onClick={() => {
                  readAllNotifcation();
                }}
              >
                {lang("Read All")}
              </Button>
            </div>
          </>
        }
      >
        {loading ? (
          <Skeleton active />
        ) : list?.length === 0 ? (
          <p style={{ textAlign: "center", padding: "40px" }}>
            <Empty
              image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
              imageStyle={{
                height: 60,
              }}
              description={
                <Typography.Text>
                  {lang("No Notification")}
                </Typography.Text>
              }
            />
          </p>
        ) : (
          <>
              {list?.map((data, index) => {
                return (
                  <div className="notification-card">
                    <h4 className="main-logo-header-ui98">
                      {moment(
                        data?.notifications?.[0]?.created_at ||
                        data?.notifications?.[0]?.createdAt
                      ).format("YYYY-MM-DD") === dates.today
                        ? lang("Today's Notifications")
                        : moment(
                          data?.notifications?.[0]?.created_at ||
                          data?.notifications?.[0]?.createdAt
                        ).format("YYYY-MM-DD") === dates.yesterday
                          ? lang("Yesterday's Notifications")
                          : moment(
                            data?.notifications?.[0]?.created_at ||
                            data?.notifications?.[0]?.createdAt
                          ).format("YYYY-MM-DD")}
                    </h4>

                    <List
                      key={"groupItem" + index}
                      itemLayout="horizontal"
                      dataSource={data.notifications}
                      renderItem={(item, index) => (
                        <List.Item
                          className={`remamber-main ${item?.is_read
                            ? "Notification-read"
                            : "Notification-unread"
                            }`}
                        >
                          <List.Item.Meta
                            onClick={() => handleNavigate(item)}
                            avatar={<Avatar src={"Prouser"} />}
                            title={
                              <div className="main-time-for998">
                                <div className="main-new-food-cart-header-nothidhi">
                                  {" "}
                                  {language !== "en" && language !== null
                                    ? item?.[`${lang}_title`] ?? item?.title
                                    : item?.title}
                                </div>
                                <h6>
                                  {moment(
                                    item?.createdAt || item?.created_at
                                  ).format("hh:mm a")}
                                </h6>
                              </div>
                            }
                            description={
                              <div
                                className="pt-1"
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div style={{ display: "inline" }}>
                                  {language !== "en" && language !== null
                                    ? item?.[`${lang}_description`] ??
                                    item?.description
                                    : item?.description}
                                </div>

                                <div className="main-new-delete-button">
                                  <div
                                    className="main-delete-out"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSelected(item?._id);
                                      setShow(true);
                                    }}
                                  >
                                    <DeleteOutlined />
                                  </div>
                                </div>
                              </div>
                            }
                          />
                        </List.Item>
                      )}
                    />
                  </div>
                );
              })}
            <div style={{ display: "flex", justifyContent: "flex-end", padding: "16px 24px" }}>
              <Pagination
                current={pagination.current}
                pageSize={pagination.pageSize || 10}
                total={pagination.total || 0}
                onChange={handlePageChange}
                showSizeChanger
                pageSizeOptions={["10", "20", "50", "100"]}
              />
            </div>
          </>
        )}

        {show && (
          <DeleteModal
            title={lang("Delete Notification")}
            subtitle={lang(
              `Are you sure you want to delete this notification?`
            )}
            show={show}
            hide={() => {
              setShow(false);
              setSelected("");
            }}
            onOk={(value) => deleteNotification(value)}
          />
        )}

        {showAllDelete && (
          <DeleteModal
            title={lang("Delete All Notification")}
            subtitle={lang(`Are you sure you want to delete all notification?`)}
            show={showAllDelete}
            hide={() => {
              setShowAllDelete(false);
              setSelected("");
            }}
            onOk={(value) => {
              setSelected();
              deleteNotification();
            }}
          />
        )}
      </Card>
    </>
  );
};

function Index() {
  const [selectedTab, setSelectedTab] = useState("list");

  const handleTabChange = (status) => {
    setSelectedTab(status);
  };

  return (
    <div className="tabled quoteManagement">
      <Row gutter={[24, 0]}>
        <Col span={24} md={24} xl={24}>
          <Card bordered={false} className="criclebox tablespace mb-24">
            <Tabs
              className="main_tabs"
              onTabClick={handleTabChange}
              activeKey={selectedTab}
              tabBarStyle={{ color: "green" }}
            >
              <TabPane tab={"Notification List"} key={"list"}>
                <NotificationList />
              </TabPane>

              <TabPane tab={"Push Notifications"} key={"push"}>
                <PushNotification />
              </TabPane>

              <TabPane tab={"Notification Templates"} key={"template"}>
                <NotificationTemplate />
              </TabPane>
            </Tabs>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default Index;
